import { useMemo } from 'react';
import { useMusic24Capabilities } from '../../hooks/useMusic24Capabilities';
import { SMLNavGroup, visibleNavGroups } from '../smlNavigation';

/** The navigation groups with only the items the plan of the active workspace allows. */
export function useVisibleNavGroups(): SMLNavGroup[] {
  const { canUseAiReels } = useMusic24Capabilities();
  return useMemo(() => visibleNavGroups({ canUseAiReels }), [canUseAiReels]);
}
